var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFireflinkLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_7284",
    "data-name": "Group 7284",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 26.437,
    viewBox: "0 0 130 26.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fireflink_Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7277",
    "data-name": "Group 7277",
    transform: "translate(29.983 7.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M49.189,13.376v2.776h5.553v2.776H49.189v4.334H45.6V10.6h9.887v2.776h-6.3Z",
    transform: "translate(-45.6 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M63,10.6h3.589V23.2H63Z",
    transform: "translate(-51.217 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M77.653,19.877H75.689V23.2H72.1V10.6h5.756c3.454,0,5.62,1.761,5.62,4.672a4.209,4.209,0,0,1-2.438,4L83.747,23.2H79.955Zm.068-6.5H75.757v3.657H77.72c1.49,0,2.235-.677,2.235-1.828C79.887,14.121,79.21,13.376,77.72,13.376Z",
    transform: "translate(-54.155 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M102.19,20.419V23.2H92.1V10.6h9.887v2.776H95.621v2.1h5.62v2.641h-5.62v2.3Z",
    transform: "translate(-60.612 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M113.689,13.376v2.776h5.553v2.776h-5.553v4.334H110.1V10.6h9.887v2.776h-6.3Z",
    transform: "translate(-66.423 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M127.4,10.6h3.589v9.751h6.027V23.2h-9.548V10.6Z",
    transform: "translate(-72.008 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M143.9,10.6h3.589V23.2H143.9Z",
    transform: "translate(-77.335 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M165.086,10.6V23.2h-2.912l-5.553-6.7v6.7H153.1V10.6h2.912l5.553,6.7V10.6Z",
    transform: "translate(-80.305 -10.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M179.576,18.658l-1.354,1.422v3.183H174.7V10.6h3.521v5.214L183.1,10.6h3.928l-5.146,5.553L187.3,23.2h-4.131Z",
    transform: "translate(-87.278 -10.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M-1141.165-445.883c-.339.2-.609.339-.88.474-1.016.542-1.964,1.016-2.979,1.557a.409.409,0,0,0-.2.406v20.518c0,.271-.068.474-.338.542a3.393,3.393,0,0,1-3.115-.271,3.137,3.137,0,0,1-1.286-2.031,18.207,18.207,0,0,1-.2-3.318c-.068-5.417-.135-10.9-.135-16.32a5.186,5.186,0,0,1,.474-2.506,3.032,3.032,0,0,1,3.589-1.625,9.961,9.961,0,0,1,2.709,1.287c.745.406,1.49.813,2.167,1.219C-1141.3-446.018-1141.232-445.95-1141.165-445.883Z",
    transform: "translate(1150.319 448.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M-1136.6-422.605V-428.5a.483.483,0,0,1,.2-.406c2.3-1.287,4.6-2.573,6.839-3.86.609-.339,1.219-.677,1.9-1.083a10.95,10.95,0,0,0-1.219-.677c-1.016-.609-2.031-1.151-3.047-1.761a.3.3,0,0,0-.339,0c-1.287.813-2.505,1.557-3.792,2.37-.068,0-.068.068-.135.068v-4.334a.615.615,0,0,1,.2-.474c1.151-.813,2.3-1.557,3.386-2.37a.432.432,0,0,1,.406,0c1.557.88,3.183,1.828,4.74,2.709,1.083.609,2.167,1.219,3.318,1.828a4.806,4.806,0,0,1,1.964,1.9,2.862,2.862,0,0,1-.406,3.318,6.586,6.586,0,0,1-1.9,1.49c-1.557.88-3.047,1.828-4.6,2.709-1.964,1.151-3.86,2.235-5.823,3.386C-1135.516-423.283-1136.058-422.944-1136.6-422.605Z",
    transform: "translate(1145.89 446.152)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireflinkLogo);
export default __webpack_public_path__ + "static/media/fireflink_logo.5645c8cdc63ba00d95294edcf9c95f32.svg";
export { ForwardRef as ReactComponent };